import '@shared/types-v0.1.0'
//@ts-ignore
import { defineNode } from '@noodl/noodl-sdk'
import { jsNode, reactNode } from '@shared/node-v1.0.0'
import systemLoaderAnimation from '@shared/system-loader-animation-v0.2.0'
import { set } from 'shared/src/libs/just'

systemLoaderAnimation.start()

import v200 from '@nodes/app-v2.0.0'
import v210 from '@nodes/app-v2.1.0'

const app = reactNode(
	'App',
	{
		'v2.0.0': v200,
		'v2.1.0': v210,
	},
	{ allowChildren: true, docs: '' }
)

import navigation010 from '@nodes/navigation-v0.1.0'

const navigation = jsNode(
	'navigation',
	{
		'v0.1.0': navigation010,
	},
	{ docs: '', color: 'purple' }
)

import navigate010 from '@nodes/navigate-v0.1.0'

const navigate = jsNode(
	'navigate',
	{
		'v0.1.0': navigate010,
	},
	{ docs: '', color: 'purple' }
)

const jsPackages = [navigation, navigate]

set(
	window,
	['R', 'packages', 'app'],
	[
		{
			name: 'Rolder Kit - App',
			type: '',
			subCategories: [
				{
					name: '',
					items: ['rolder-kit.api-v1.App'],
				},
				{
					name: 'Navigation',
					items: ['rolder-kit.api-v1.navigation', 'rolder-kit.api-v1.navigate'],
				},
			],
		},
	]
)

Noodl.defineModule({
	name: 'app',
	reactNodes: [app],
	nodes: jsPackages.map(defineNode),
	settings: [
		{
			name: 'project',
			type: 'string',
			displayName: 'Project name',
			group: 'Rolder',
			tooltip: 'Examples: rasko, tex',
		},
		{
			name: 'projectVersion',
			type: 'string',
			displayName: 'Project version',
			group: 'Rolder',
		},
		{
			name: 'environment',
			type: {
				name: 'enum',
				enums: [
					{ label: 'd2', value: 'd2' },
					{ label: 't2', value: 't2' },
					{ label: 'p2', value: 'p2' },
					{ label: 'd3', value: 'd3' },
					{ label: 't3', value: 't3' },
					{ label: 'p3', value: 'p3' },
				],
			},
			default: 'd3',
			displayName: 'Project environment',
			group: 'Rolder',
		},
		{
			name: 'projectDefaults',
			type: 'array',
			displayName: 'Project defaults',
			group: 'Rolder',
		},
		{
			name: 'warnDeprecated',
			type: 'boolean',
			displayName: 'Warn deprecated',
			group: 'Rolder',
			default: false,
		},
	],
})
